import { apiClient } from '../services/api';
import type {
  SlackConnectionStatus,
  SlackSettings,
  SlackChannel,
  SlackUserLink,
  SlackTestResult,
  UpdateSlackSettingsInput,
} from '../types/slack.types';

interface ApiResponse<T> {
  status: string;
  data: T;
  message?: string;
}

export const slackApi = {
  // ===========================================
  // OAUTH AUTHENTICATION
  // ===========================================

  getAuthUrl: (): Promise<{ authUrl: string }> =>
    apiClient
      .get<ApiResponse<{ authUrl: string }>>('/integrations/slack/auth-url')
      .then((res) => res.data),

  getStatus: (): Promise<SlackConnectionStatus> =>
    apiClient
      .get<ApiResponse<SlackConnectionStatus>>('/integrations/slack/status')
      .then((res) => res.data),

  disconnect: (): Promise<void> =>
    apiClient.delete('/integrations/slack').then(() => undefined),

  testConnection: (): Promise<SlackTestResult> =>
    apiClient
      .post<ApiResponse<SlackTestResult>>('/integrations/slack/test')
      .then((res) => res.data),

  // ===========================================
  // SETTINGS
  // ===========================================

  getSettings: (): Promise<SlackSettings> =>
    apiClient
      .get<ApiResponse<SlackSettings>>('/integrations/slack/settings')
      .then((res) => res.data),

  updateSettings: (input: UpdateSlackSettingsInput): Promise<SlackSettings> =>
    apiClient
      .put<ApiResponse<SlackSettings>>('/integrations/slack/settings', input)
      .then((res) => res.data),

  listChannels: (): Promise<SlackChannel[]> =>
    apiClient
      .get<ApiResponse<SlackChannel[]>>('/integrations/slack/channels')
      .then((res) => res.data),

  // ===========================================
  // USER LINKING
  // ===========================================

  linkUser: (data: { slackUserId: string }): Promise<SlackUserLink> =>
    apiClient
      .post<ApiResponse<SlackUserLink>>('/integrations/slack/link', data)
      .then((res) => res.data),

  unlinkUser: (): Promise<void> =>
    apiClient.delete('/integrations/slack/unlink').then(() => undefined),

  getLinkedUsers: (): Promise<SlackUserLink[]> =>
    apiClient
      .get<ApiResponse<SlackUserLink[]>>('/integrations/slack/users')
      .then((res) => res.data),
};
